'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JS Modules
import { builderDispatch, PrismUI } from '../../_utils/ui';

class EnvelopePage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: this.envelopeSize()
    };

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.token = builderDispatch.register((payload) => {
      switch (payload.type) {
        case PrismUI.ITEM_LOADED:
          this.setState({ size: this.envelopeSize() });
          break;
        case PrismUI.TRIGGER_ENVELOPE_ADDRESS_FORM:
          payload.payload !== 'blank' ? this.handleClick() : null;
          break;
      }
    });
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.token);
  }

  render() {
    return (
      <div className="envelope-page w-100 mb-sm-2">
        <div className={classNames(`envelope-bg envelope-bg-${ this.state.size }`, { blank: this.blank })}
             onClick={ this.handleClick }>
          <div className={ `address-wrapper align-${ this.state.size }` }>
            { this.renderAddress() }
          </div>
        </div>
      </div>
    );
  }

  renderAddress() {
    if (!this.useAddress()) return null;

    const address = this.address();

    if (!address || Object.keys(address).length === 0) {
      return (
        <button className='btn btn-link no-address' aria-label='Enter address here'>
          <div>Enter address here&hellip; (required)</div>
        </button>
      );
    }

    const { name, streetAdd1, streetAdd2, city, state, zip } = address;

    const ariaLabel = [
      'Edit address',
      name,
      streetAdd1,
      streetAdd2,
      this.addressLine(city, state),
      zip,
    ].filter(Boolean).join(', '); // removes empty/undefined values

    return (
      <button className='btn btn-link address' aria-label={ariaLabel}>
        <span className='d-block'>{name}</span>
        <span className='d-block'>{streetAdd1} {streetAdd2}</span>
        <span className='d-block'>{this.addressLine(city, state)} {zip}</span>
      </button>
    );
  }


  handleClick() {
    this.props.onClick && this.props.onClick();
  }

  address() {
    return wkData.values.returnAddress || {};
  }

  useAddress() {
    return !!wkData.values.useReturnAddress;
  }

  addressLine(...strings) {
    return strings.filter(Boolean).join(', ');
  }

  envelopeSize() {
    return wkData.product.title.split(' ')[0];
  }

  envelopeBgSrc() {
    return '/images/' + this.envelopeSize() + '_envelope.png';
  }

  get blank() {
    return !wkData.features.includes('ReturnAddress');
  }
}

export default EnvelopePage;
